import React from 'react'
import { UploadSupplierFormBuyerStyle } from './styled'
import { supplierManagementBuyerController } from '../../apiService'
import {
  Button,
  Image,
  InputUpload,
  Section,
  Spinner,
  Breadcrumbs,
} from '../../components'
import FileDownload from 'js-file-download'

import { ICONS } from '../../themes'
import Moment from 'moment'

import { ROUTE_PATH, STRING, toastFail, toastActive } from '../../helpers'

export class UploadSupplierFormBuyerContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedFile: null,
      selectedFilePlaceholder: null,
      uploadSupplier: [],
      isLoading: false,
      uploadFail: false,
    }
    this.renderUploadSupplier = this.renderUploadSupplier.bind(this)
  }

  onClickCancel = () => {
    this.props.history.push(ROUTE_PATH.SUPPLIER_MANAGEMENT_BUYER.LINK)
  }
  // On file select (from the pop up)
  onFileChange = event => {
    // Update the state
    this.setState({ uploadFail: false })
    const value = event.target.files[0]
    var res = value.name.substr(value.name.lastIndexOf('.')) === '.xlsx'
    if (res) {
      this.setState({ selectedFile: value })
      this.setState({ selectedFilePlaceholder: value })
    } else {
      toastFail('Incorrect file format')
    }
  }

  _downloadTemplateLink() {
    return supplierManagementBuyerController()
      .downloadTemplateSupplier()
      .then(res =>
        FileDownload(
          res.data,
          'download_template_' + Moment().format('DDMMyyyy_hhmm') + '.xlsx'
        )
      )
  }

  _downloadOfflineSupplierLink() {
    this.setState({ isLoading: true })
    return supplierManagementBuyerController()
      .downloadSupplier()
      .then(res => {
        this.setState({ isLoading: false })
        FileDownload(
          res.data,
          'download_offline_supplier_' +
            Moment().format('DDMMyyyy_hhmm') +
            '.xlsx'
        )
      })
  }

  _fileUpload() {
    this.setState({ isLoading: true, uploadFail: false })
    if (this.state.selectedFile === null) {
      toastFail('Please browse your file')
      this.setState({ isLoading: false })
    } else {
      let formData = new FormData()
      formData.append('file', this.state.selectedFile)
      return supplierManagementBuyerController()
        .uploadSupplier(formData)
        .then(res => {
          console.log('uploadSupplier', res)
          if (res) {
            if (res.status === 'success') {
              toastActive('Upload successfully')
              this.setState({
                selectedFile: null,
                isLoading: false,
                uploadSupplier: res,
              })
            } else if (res.status === 'Fail' || res.status === 'fail') {
              toastFail('Please Check Your Error')
              this.setState({ uploadSupplier: res, isLoading: false })
            } else {
              toastFail('Error')
              this.setState({ isLoading: false, uploadFail: true })
            }
          } else {
            this.setState({ isLoading: false, uploadFail: true })
          }
        })
        .catch(err => {
          this.setState({ isLoading: false, uploadFail: true })
          throw err
        })
    }
  }
  renderUploadSupplier = () => {
    const {
      uploadSupplier,
      selectedFile,
      isLoading,
      selectedFilePlaceholder,
    } = this.state
    const funcLoading = () => {
      if (isLoading) {
        return <Spinner className="loading" />
      }
    }
    const renderPageTitle = () => {
      const handlerClickBreadcrumbsHome = e => {
        return this.props.history.push(ROUTE_PATH.HOME.LINK)
      }
      const handlerClickBreadcrumbsManagement = e => {
        return this.props.history.push(
          ROUTE_PATH.SUPPLIER_MANAGEMENT_BUYER.LINK
        )
      }
      return (
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_supplier_management"
                src={ICONS['icon-user-group-white.svg']}
                alt="page icon"
              />
            </Section>

            <Section className="title-and-breadcrumb">
              <Section id="page_title_supplier_management" className="title">
                {STRING.SUPPLIER_MANAGEMENT}
              </Section>
              <Breadcrumbs props={this.props} />
            </Section>
          </Section>
        </Section>
      )
    }
    const funcRenderPageContent = () => {
      const onClickFileUpload = e => {
        if (e.detail === 1) {
          return this._fileUpload()
        }
      }
      const onClickTemplateLink = e => {
        if (e.detail === 1) {
          return this._downloadTemplateLink()
        }
      }
      const onClickDownloadOffline = e => {
        if (e.detail === 1) {
          return this._downloadOfflineSupplierLink()
        }
      }
      const renderUploadSupplierStatus = () => {
        if (
          !!uploadSupplier.status &&
          (uploadSupplier.status === 'Fail' || uploadSupplier.status === 'fail')
        ) {
          if (uploadSupplier.result.message) {
            return uploadSupplier.result.message
          } else {
            return uploadSupplier.result.map((e, i) => {
              const validLenght = e.InValid.length
              const validNewline = e.InValid.map((text, i) => {
                return (
                  <React.Fragment key={text}>
                    {validLenght === i + 1 ? (
                      <>
                        {text} <br />
                      </>
                    ) : (
                      <>
                        {text}, <br />
                      </>
                    )}
                  </React.Fragment>
                )
              })
              return (
                <span className="error" key={i}>
                  <React.Fragment>
                    Row {e.Row}
                    <br /> {validNewline}
                  </React.Fragment>
                </span>
              )
            })
          }
        } else {
          if (uploadSupplier.result) {
            try {
              return (
                <span className="success">{uploadSupplier.result.message}</span>
              )
            } catch (error) {
              console.log(error)
            }
          }
        }
      }
      const renderLodingTimeout = () => {
        if (this.state.uploadFail) {
          return <span className="error">Upload Timeout</span>
        }
      }
      const funcClickCancel = e => {
        if (e.detail === 1) {
          return this.onClickCancel()
        }
      }
      return (
        <Section className="main-content form">
          <Section className="content-body">
            <Section className="form-wrapper">
              <Section className="form-group-title">Upload Supplier</Section>
              <Section className="form-group ">
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <InputUpload
                      id="upload"
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      onChange={this.onFileChange}
                      selectedFileName={selectedFile ? selectedFile.name : ''}
                      placeholder={
                        selectedFilePlaceholder
                          ? selectedFilePlaceholder.name
                          : ''
                      }
                    />
                    <Button className="theme-blue" onClick={onClickFileUpload}>
                      Upload
                    </Button>
                  </Section>
                </Section>
              </Section>
              <a
                className="file-download-link"
                href="#"
                onClick={onClickTemplateLink}
              >
                Download Template
              </a>
              <span className="divider">|</span>
              <a
                className="file-download-link"
                href="#"
                onClick={onClickDownloadOffline}
              >
                Download Offline Supplier
              </a>
              <Section className="form-group">
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <div className="upload-log-outter-wrapper">
                      <Section className="lists-wrapper">
                        <div className="upload-log-wrapper">
                          {renderUploadSupplierStatus()}
                          {renderLodingTimeout()}
                        </div>
                      </Section>
                    </div>
                  </Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-actions">
              <Button className="theme-border-gray" onClick={funcClickCancel}>
                Cancel
              </Button>
            </Section>
          </Section>
        </Section>
      )
    }
    return (
      <UploadSupplierFormBuyerStyle>
        {funcLoading()}
        {renderPageTitle()}
        {funcRenderPageContent()}
      </UploadSupplierFormBuyerStyle>
    )
  }
  render = () => this.renderUploadSupplier()
}
